import React, { useEffect, useState } from 'react';

import { Alert } from '@wds/alert';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';

import PropTypes from 'prop-types';

const AlertBanner = (props) => {
	const { alert } = props;
	const [content, setContent] = useState();
	const [show, setShow] = useState(true);

	const colorMap = {
		0: 'warning',
		1: 'error',
		2: 'info',
	};

	function parseContent(alertContent) {
		const anchorTagRegex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1>(.*?)<\/a>/gi;

		const parts = [];
		let lastIndex = 0;

		alertContent.replace(anchorTagRegex, (match, p1, href, text, offset) => {
			parts.push(alertContent.slice(lastIndex, offset));
			parts.push(
				// TODO: support data-attributes so that we can keep amplitude analytics flowing
				<Typography
					key={offset}
					lineHeight='normal'
					variant='link'
					component='a'
					href={href}
					target='_blank'
				>
					{text}
				</Typography>,
			);
			lastIndex = offset + match.length;
		});
		parts.push(alertContent.slice(lastIndex));
		return parts;
	}

	useEffect(() => {
		if (alert?.content) {
			setContent(parseContent(alert.content));
		}
	}, [alert?.content]);

	const dismissBanner = () => {
		const storageKey = `systemnotification-${alert.id}`;
		localStorage.setItem(storageKey, 'hide');
		setShow(false);
	};

	return (
		<Alert
			show={show}
			onClose={dismissBanner}
			showIcon
			dismissible={alert?.dismissible}
			color={colorMap[alert?.color]}
			closeButtonLabel='Close Alert'
			data-testid={alert?.title}
		>
			<Box element='span' display='flex' justifyContent='start' gap={1}>
				<Box element='span'>
					{alert?.title}
					:
				</Box>
				<Box element='span'>{content}</Box>
			</Box>
		</Alert>
	);
};

AlertBanner.propTypes = {
	alert: PropTypes.shape({
		title: PropTypes.string,
		content: PropTypes.string,
		button_text: PropTypes.string,
		color: PropTypes.number,
		dismissible: PropTypes.bool,
	}),
};
AlertBanner.defaultProps = {
	alert: {
		title: '',
		content: '',
		button_text: '',
		color: 0,
		dismissible: false,
	},
};

export default AlertBanner;
